export function partnerType() {
  return (dispatch) => {
    const partner_type = window.location.href.indexOf("partner.") > 0? 'partner': 'app';
    dispatch({
      type: 'PARTNER_TYPE',
      status: partner_type
    });
  }
}